import { HotjarTrigger, FormatTriggerOptions } from './types'
import { SOURCE_BY_LIVE_ORING, HOTJAR_LANGUAGE } from './constants'

import AuthService from 'modules/auth/service'
import LanguageHelper, { Language } from 'common/helpers/language'
import { CreatedFrom } from 'modules/transmission/types'

class HotjarHelper {
  private getHj = () => {
    window.hj = window.hj || function hjq(...args: unknown[]) {
      window.hj && (window.hj.q = window.hj.q || []).push(args)
    }
    return window.hj
  }

  private triggerByLanguage: {[language in Language]: HotjarTrigger} = {
    [Language.AR]: HotjarTrigger.WEBINAR_AR,
    [Language.EN]: HotjarTrigger.WEBINAR_EN,
    [Language.ES]: HotjarTrigger.WEBINAR_ES,
    [Language.FR]: HotjarTrigger.WEBINAR_FR,
    [Language.PT]: HotjarTrigger.WEBINAR_PT
  }

  get hj() {
    return this.getHj()
  }

  private formatTrigger = (triggerName: HotjarTrigger, options: FormatTriggerOptions) => {
    let processedTrigger: string = triggerName

    if (options.source) {
      processedTrigger = `${processedTrigger}_${SOURCE_BY_LIVE_ORING[options.source]}`
    }

    if (options.withLanguage) {
      processedTrigger = `${processedTrigger}_${HOTJAR_LANGUAGE[LanguageHelper.currentLanguage]}`
    }

    return processedTrigger
  }

  trigger = (triggerName: HotjarTrigger, options?: FormatTriggerOptions, timeToWait = 2000) => {
    if (!AuthService.isProduction) {
      return
    }

    const formattedTrigger = options
      ? this.formatTrigger(triggerName, options)
      : triggerName

    setTimeout(() => {
      this.hj('trigger', formattedTrigger)
    }, timeToWait)
  }

  triggerWithSource = (triggerName: HotjarTrigger, source?: CreatedFrom) => {
    this.trigger(triggerName, { source })
  }

  dispatchLanguageTrigger = () => {
    this.trigger(this.triggerByLanguage[LanguageHelper.currentLanguage])
  }

  triggerWithLanguage = (triggerName: HotjarTrigger) => {
    this.trigger(triggerName, { withLanguage: true })
  }
}

export default new HotjarHelper()
